import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import apiClient from '@/utils/api';

let cache = null;

export const sectorName = (cat, lang) => cat?.[`name_${lang}`] || cat?.name_pt || cat?.slug || '';

export function useSectors() {
  const { i18n } = useTranslation();
  const [sectors, setSectors] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    apiClient.get('/categories')
      .then((r) => { cache = r.data?.items || []; setSectors(cache); })
      .catch(() => setSectors([]));
  }, []);
  const lang = (i18n.language || 'pt').slice(0, 2);
  return { sectors, lang, nameOf: (slugOrCat) => sectorName(typeof slugOrCat === 'string' ? sectors.find((s) => s.slug === slugOrCat) : slugOrCat, lang) };
}
